module.exports = __webpack_public_path__ + "static/media/no_wifi.c09d6763.svg";